import SEO from '../components/SEO';
import HeroSection from '../components/sections/HeroSection';
import BenefitsSection from '../components/sections/BenefitsSection';
import ProductSection from '../components/sections/ProductSection';
import IngredientsSection from '../components/sections/IngredientsSection';
import HowItWorksSection from '../components/sections/HowItWorksSection';
import TestimonialsSection from '../components/sections/TestimonialsSection';
import WhyReloadSection from '../components/sections/WhyReloadSection';
import FAQSection from '../components/sections/FAQSection';
import FinalCTASection from '../components/sections/FinalCTASection';
import MarqueeSection from '../components/sections/MarqueeSection';
import BlogPreviewSection from '../components/sections/BlogPreviewSection';

const homeSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': 'https://reload-nutrition.com/#organization',
      name: 'RELOAD Nutrition',
      url: 'https://reload-nutrition.com',
      logo: 'https://customer-assets.emergentagent.com/job_reload-performance/artifacts/uu3trnls_Render_Mockup_1920_1920_2026-03-14-2.jpg',
      sameAs: [],
    },
    {
      '@type': 'WebSite',
      '@id': 'https://reload-nutrition.com/#website',
      url: 'https://reload-nutrition.com',
      name: 'RELOAD Nutrition',
      publisher: { '@id': 'https://reload-nutrition.com/#organization' },
    },
    {
      '@type': 'Product',
      name: 'RELOAD Male Performance Formula',
      description: 'Premium natural botanical supplement designed to increase semen volume, help men ejaculate more, boost pre-cum, and support male reproductive health. 60 capsules, 30-day supply.',
      brand: { '@type': 'Brand', name: 'RELOAD Nutrition' },
      url: 'https://reload-nutrition.com/shop',
      image: 'https://customer-assets.emergentagent.com/job_reload-performance/artifacts/uu3trnls_Render_Mockup_1920_1920_2026-03-14-2.jpg',
      offers: {
        '@type': 'Offer',
        price: '24.99',
        priceCurrency: 'GBP',
        availability: 'https://schema.org/InStock',
        url: 'https://reload-nutrition.com/shop',
        priceValidUntil: '2027-12-31',
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: { '@type': 'MonetaryAmount', value: '0', currency: 'GBP' },
          shippingDestination: { '@type': 'DefinedRegion', addressCountry: 'GB' },
        },
      },
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '4.9',
        reviewCount: '2000',
        bestRating: '5',
      },
    },
  ],
};

export default function Home() {
  return (
    <main data-testid="home-page">
      <SEO
        title="Increase Semen Volume &amp; Ejaculate More | Natural Supplement UK"
        description="RELOAD is a premium natural supplement designed to increase semen volume, help you cum more, boost pre-cum, and ejaculate more. Plant-based formula. £24.99. UK delivery."
        canonical="/"
        schema={homeSchema}
      />
      <HeroSection />
      <MarqueeSection />
      <BenefitsSection />
      <ProductSection />
      <IngredientsSection />
      <HowItWorksSection />
      <TestimonialsSection />
      <WhyReloadSection />
      <BlogPreviewSection />
      <FAQSection />
      <FinalCTASection />
    </main>
  );
}
